import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import '../../../../../setup-sentry';
import { SessionExpired, Unauthorised } from './errors';
import { SentryConsentService } from './sentry-consent.service';

const IGNORED_ERRORS = [SessionExpired, Unauthorised];

@Injectable({
    providedIn: 'root'
})
export class FlyFreelyErrorHandler implements ErrorHandler {
    constructor(private sentryConsent: SentryConsentService) {}

    handleError(error: any) {
        if (error == null) {
            // zone.js >= 0.14.3 rethrows unhandled Promise rejections with their raw value.
            // A dismissed common dialogue rejects with undefined/null, so there is nothing to report.
            return;
        }
        if (
            !(
                IGNORED_ERRORS.findIndex(e => error instanceof e) !== -1 ||
                IGNORED_ERRORS.findIndex(
                    e => error.originalError instanceof e
                ) !== -1
            )
        ) {
            // @ts-ignore - type sense not available
            if (window.__DEV__) {
                window.console.error(error.originalError || error);
            }
            if (this.sentryConsent.allowSentry) {
                Sentry.captureException(error.originalError || error);
            }
        }
    }

    warning(message: any, extra: Record<string, unknown> = undefined) {
        // @ts-ignore - type sense not available
        if (window.__DEV__) {
            window.console.warn(message);
        }
        if (this.sentryConsent.allowSentry) {
            Sentry.captureMessage(message, { level: 'warning', extra });
        }
    }

    logErrorMessage(message: any, extra: Record<string, unknown> = undefined) {
        // @ts-ignore - type sense not available
        if (window.__DEV__) {
            window.console.error(message);
        }
        if (this.sentryConsent.allowSentry) {
            Sentry.captureMessage(message, { level: 'error', extra });
        }
    }
}

export const flyFreelyErrorHandlerProvider = {
    provide: ErrorHandler,
    useClass: FlyFreelyErrorHandler
};
